import { useEffect, useState } from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { getDealerUsage } from '../../api/backendApi';

const ELIGIBILITY = {
  final: 'Calculated',
  beta_estimate: 'Beta estimate',
  estimate_requires_review: 'Estimate',
  not_configured: 'Not configured',
  pricing_incomplete: 'Pricing incomplete',
  not_yet_billable: 'Not yet billable',
  currency_mismatch: 'Other currency',
};

export default function DealerUsageReport({ dealerId, tenantId }) {
  const [currency, setCurrency] = useState('CAD');
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (!dealerId || !tenantId) return undefined;
    let canceled = false;
    getDealerUsage(dealerId, tenantId, currency)
      .then((response) => {
        if (!canceled) setReport(response?.data || null);
      })
      .catch(() => {
        if (!canceled) setReport(null);
      });
    return () => {
      canceled = true;
    };
  }, [dealerId, tenantId, currency]);

  return (
    <Box sx={{ display: 'grid', gap: 1, mt: 2 }}>
      <Typography variant="h6">Monthly usage and margin</Typography>
      <Typography variant="body2">
        Amounts are commercial calculations for review. They are not an invoice or an amount due.
      </Typography>
      <TextField select label="Currency" value={currency} onChange={(event) => setCurrency(event.target.value)} sx={{ maxWidth: 240 }}>
        <MenuItem value="CAD">CAD</MenuItem>
        <MenuItem value="USD">USD</MenuItem>
      </TextField>
      {report ? (
        <Box>
          {report.commercialBeta ? (
            <Typography sx={{ fontWeight: 600 }}>
              {report.label || 'BETA ESTIMATE — NOT BILLABLE'}. No amount is payable.
            </Typography>
          ) : null}
          <Typography>
            Estimate wholesale {report.totals?.estimateWholesale || report.totals?.finalWholesale || '0'} · Estimate retail {report.totals?.estimateRetail || report.totals?.finalRetail || '0'} · Estimate margin {report.totals?.estimateMargin || report.totals?.finalMargin || '0'} {report.currency}
          </Typography>
          {(report.warnings || []).map((warning) => (
            <Typography key={warning} variant="body2">{warning}</Typography>
          ))}
          {(report.lines || []).map((line, index) => (
            <Typography key={`${line.featureId || 'line'}-${index}`} variant="body2">
              {line.featureName || 'Usage'}: {line.quantity || '—'} {line.billingUnit || ''} · {ELIGIBILITY[line.eligibility] || line.eligibility}
              {line.allowance ? ` · allowance ${line.allowance}` : ''}
            </Typography>
          ))}
        </Box>
      ) : null}
    </Box>
  );
}
